import { render } from "./NewProductSelection.vue?vue&type=template&id=50e320af&scoped=true"
import script from "./NewProductSelection.vue?vue&type=script&lang=js"
export * from "./NewProductSelection.vue?vue&type=script&lang=js"

import "./NewProductSelection.vue?vue&type=style&index=0&id=50e320af&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e320af"]])

export default __exports__